export default __webpack_public_path__ + "static/media/Flower.5207db3d.svg";